import { CSSProperties, ReactNode } from "react";

interface PageHeaderProps {
  title: ReactNode;
  onClose: () => void;
  style?: CSSProperties;
  /** Extra content rendered next to the title (e.g. a HelpTip), as in MealView. */
  children?: ReactNode;
}

/**
 * Shared detail-view header that replaces the repeated
 * header-row/header-title/btn-close markup duplicated across ListView.tsx
 * and MealView.tsx.
 */
export function PageHeader({ title, onClose, style, children }: PageHeaderProps) {
  const heading = <h1 className="header-title">{title}</h1>;
  return (
    <div className="header-row" style={style}>
      {children ? (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {heading}
          {children}
        </div>
      ) : (
        heading
      )}
      <button onClick={onClose} className="btn-close">&times;</button>
    </div>
  );
}
